export default __webpack_public_path__ + "static/media/fsiRealCase1-mobile-en.91e8ae3e.jpg";